import PropTypes from "prop-types";

const Avatar = ({ name, imageUrl, size = "md" }) => {
  const sizes = {
    sm: "w-8 h-8 text-sm",
    md: "w-10 h-10 sm:w-12 sm:h-12 text-base sm:text-lg",
    lg: "w-14 h-14 sm:w-16 sm:h-16 text-lg sm:text-xl",
  };

  const getInitials = (name) => {
    if (!name) return "L";
    const words = name.trim().split(/\s+/);
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  const sizeClass = sizes[size] || sizes.md;

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={name}
        className={`${sizeClass} rounded-xl object-contain shrink-0 bg-white`}
        style={{ boxShadow: "0 1px 4px rgba(0,0,0,0.1)" }}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-xl flex items-center justify-center shrink-0`}
      style={{ backgroundColor: "#01793B" }}
    >
      <span className="text-white font-bold">
        {getInitials(name)}
      </span>
    </div>
  );
};

Avatar.propTypes = {
  name: PropTypes.string,
  imageUrl: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};

export default Avatar;
